import React from 'react';
import styled from 'styled-components';

type Props = {
  img: string;
};

function ImageCover({ img }: Props) {
  return (
    <Cover>
      <img src={img} alt='' />
    </Cover>
  );
}

const Cover = styled.div`
  position: absolute;
  top: 83px;
  width: 100%;
  padding: 0 24px;
  overflow: hidden;
  object-fit: contain;
  background-color: #eef4ff;

  & > img {
    width: 100%;
    height: 100%;
  }
`;

export default ImageCover;
